import { Box, SxProps, Theme, useTheme } from '@mui/material'

export interface PhaseSelectorProps {
  value: [boolean, boolean, boolean]
  onChange: (value: [boolean, boolean, boolean]) => void
  sx?: SxProps<Theme>
}

export function PhaseSelector(props: PhaseSelectorProps): JSX.Element {
  const { value, sx, onChange } = props
  const theme = useTheme()

  const sxCommon: SxProps<Theme> = {
    display: 'inline-block',
    cursor: 'pointer',
    width: '2rem',
    height: '2rem',
    lineHeight: '2rem',
    fontsize: '0.875rem',
    fontWeight: 400,
    borderRadius: '1rem',
    mx: 0.5
  }

  const sxOn: SxProps<Theme> = {
    color: theme.palette.grey[900],
    backgroundColor: 'primary.main',
  }
  const sxOff: SxProps<Theme> = {
    color: 'white',
    backgroundColor: theme.palette.grey[600],
  }

  const onClick = (idx: number) => {
    value[idx] = !value[idx]
    onChange(value)
  }

  return (
    <Box sx={{
      textAlign: 'center',
      ...sx
    }}>
      {['L1', 'L2', 'L3'].map((letter, idx) => (
        <Box
          key={idx}
          component="span"
          data-cy={`box-Phase ${letter}`}
          onClick={() => onClick(idx)}
          sx={value[idx] ? { ...sxCommon, ...sxOn } : { ...sxCommon, ...sxOff }}
          aria-valuetext={value[idx] ? letter : ''}
        >
          {letter}
        </Box>
      ))}
    </Box>
  )
}
